
import { Component, Prop, Vue } from 'vue-property-decorator'
import TitlePanel from '@/components/organisms/TitlePanel.vue'
import SelectPulldownButton from '@/components/organisms/SelectPulldownButton.vue'
import LearningChart from '@/components/organisms/LearningChart.vue'
import SidemenuLayout from '@/components/organisms/layout/SidemenuLayout.vue'
import { SystemChartDetail } from '@/models/SystemChart'

/**
 * 知識MAP
 */
@Component({
  components: {
    TitlePanel,
    SelectPulldownButton,
    LearningChart,
    SidemenuLayout,
  },
})
export default class LearningUnitMap extends Vue {
  /** 知識MAP詳細情報 */
  @Prop()
  private systemChartDetail!: SystemChartDetail | null

  /** チャート選択ボタン押下時のイベント */
  @Prop()
  private onSelectChartButton!: () => void

  /** 単元選択時のイベント */
  @Prop()
  private onSelectUnit!: (id: number) => void
}
